import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

/* Actions */
import { setAuth, setUserData } from "../../redux/actions/user";
import { toggleBurgerStatus, toggleBurgerMenu, setLogOut } from "../../redux/actions/misc";

class NavigationBar extends Component {

    state = { menuOpen: false };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (this._menuRef && !this._menuRef.contains(e.target)) {
            if (this.state.menuOpen) this.setState({ menuOpen: false });
        }
    }

    toggleMenu = () => {
        this.setState(prev => ({ menuOpen: !prev.menuOpen }));
    }

    closeMenu = () => {
        this.setState({ menuOpen: false });
    }

    initials = (firstName, lastName) => {
        const a = (firstName || "").trim()[0];
        const b = (lastName || "").trim()[0];
        return `${a || ""}${b || ""}`.toUpperCase() || "—";
    }

    handleBurgerMenu = (status) => {

        this.props.toggleBurgerStatus(status);

        return setTimeout(() => {
            return this.props.toggleBurgerMenu(true);
        }, 125);

    }

    render() {

        const { user } = this.props;
        const userReady = !user.isLoggingIn && user.isLoggedIn && user?.data?.profile?.profileType !== undefined && (user.data.profile.profileType !== "upload" || (user.data.profile.initialSetupCompleted && user.data.isVerified));
        const isAdmin = !user.isLoggingIn && user.isLoggedIn && user?.data?.userType === "Admin";

        return(
            <div className="navigation-bar-container" style={{ background: this.props.linear ? "var(--jc-midnight-900)" : "transparent"  }}>
                {userReady &&
                    <div className="navigation-bar-left-side-items-container">
                        <div className="navigation-bar-left-side-item-container" onClick={() => this.handleBurgerMenu(true)}>
                            <img src={require("../../assets/svgs/burger.svg")} alt="" />
                        </div>
                    </div>
                }
                {isAdmin &&
                    <div className="navigation-bar-left-side-items-container">
                        <div className="navigation-bar-left-side-item-container" onClick={() => this.handleBurgerMenu(true)}>
                            <img src={require("../../assets/svgs/burger.svg")} alt="" />
                        </div>
                    </div>
                }
                {!user.isLoggingIn && (user.data || !user.isLoggedIn) &&
                    <div className="navigation-bar-logo-container" style={isAdmin ? {} : !userReady ? {justifyContent: "flex-start"} : {}}>
                        {!user.isLoggedIn && !this.props?.match?.path.includes("/sign-up") && !this.props?.match?.path.includes("/sign-in") && !this.props?.match?.path.includes("/reset-password") && !this.props?.match?.path.includes("/reference-verification") &&
                            <div className="navigation-bar-no-auth-burger" onClick={() => this.handleBurgerMenu(true)}>
                                <img src={require("../../assets/svgs/burger.svg")} alt="" />
                            </div>
                        }
                        <Link to={"/"}>
                            <img src={require("../../assets/svgs/j4crew-logo-new.svg")} alt="J4Crew" />
                        </Link>
                        {!user.isLoggedIn && !this.props?.match?.path.includes("/sign-up") && !this.props?.match?.path.includes("/sign-in") && !this.props?.match?.path.includes("/reset-password") && !this.props?.match?.path.includes("/reference-verification") &&
                            <div className="navigation-bar-home-pages-menu-container">
                                <div className="navigation-bar-home-pages-menu-item-container">
                                    <Link to={"/find-jobs"} style={this.props?.match?.path === "/find-jobs" ? { fontFamily: "Inter-Bold", fontWeight: "bold" } : {}}>Find Jobs</Link>
                                </div>
                                <div className="navigation-bar-home-pages-menu-item-container">
                                    <Link to={"/looking-for-crew"} style={this.props?.match?.path === "/looking-for-crew" ? { fontFamily: "Inter-Bold", fontWeight: "bold" } : {}}>Looking for Crew?</Link>
                                </div>
                                <div className="navigation-bar-home-pages-menu-item-container">
                                    <Link to={"/about-us"} style={this.props?.match?.path === "/about-us" ? { fontFamily: "Inter-Bold", fontWeight: "bold" } : {}}>About Us</Link>
                                </div>
                                <div className="navigation-bar-home-pages-menu-item-container">
                                    <Link to={"/cv-advice"} style={this.props?.match?.path === "/cv-advice" ? { fontFamily: "Inter-Bold", fontWeight: "bold" } : {}}>CV Advice</Link>
                                </div>
                                <div className="navigation-bar-home-pages-menu-item-container">
                                    <Link to={"/contact-us"} style={this.props?.match?.path === "/contact-us" ? { fontFamily: "Inter-Bold", fontWeight: "bold" } : {}}>Contact Us</Link>
                                </div>
                            </div>
                        }
                    </div>
                }
                {user?.data &&
                    <div className="navigation-bar-right-side-items-container" ref={ref => this._menuRef = ref}>
                        <button
                            type="button"
                            className={`nav-avatar-button${this.state.menuOpen ? " is-open" : ""}`}
                            onClick={this.toggleMenu}
                            aria-haspopup="menu"
                            aria-expanded={this.state.menuOpen}
                        >
                            <span className="nav-avatar">{this.initials(user.data.firstName, user.data.lastName)}</span>
                        </button>

                        {this.state.menuOpen &&
                            <div className="nav-avatar-menu" role="menu">
                                <div className="nav-avatar-menu-header">
                                    <div className="nav-avatar nav-avatar-large">{this.initials(user.data.firstName, user.data.lastName)}</div>
                                    <div className="nav-avatar-menu-identity">
                                        <p className="nav-avatar-menu-name">{user.data.firstName} {user.data.lastName}</p>
                                        <p className="nav-avatar-menu-email">{user.data.email}</p>
                                    </div>
                                </div>
                                {userReady &&
                                    <Link to={"/settings"} className="nav-avatar-menu-item" role="menuitem" onClick={this.closeMenu}>
                                        <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M19.4 15A1.65 1.65 0 0019.73 16.82L19.79 16.88A2 2 0 1116.96 19.71L16.9 19.65A1.65 1.65 0 0015.08 19.32A1.65 1.65 0 0014.08 20.83V21A2 2 0 1110.08 21V20.91A1.65 1.65 0 009 19.4A1.65 1.65 0 007.18 19.73L7.12 19.79A2 2 0 114.29 16.96L4.35 16.9A1.65 1.65 0 004.68 15.08A1.65 1.65 0 003.17 14.08H3A2 2 0 113 10.08H3.09A1.65 1.65 0 004.6 9A1.65 1.65 0 004.27 7.18L4.21 7.12A2 2 0 117.04 4.29L7.1 4.35A1.65 1.65 0 008.92 4.68H9A1.65 1.65 0 0010 3.17V3A2 2 0 1114 3V3.09A1.65 1.65 0 0015 4.6A1.65 1.65 0 0016.82 4.27L16.88 4.21A2 2 0 1119.71 7.04L19.65 7.1A1.65 1.65 0 0019.32 8.92V9A1.65 1.65 0 0020.83 10H21A2 2 0 1121 14H20.91A1.65 1.65 0 0019.4 15Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span>Account settings</span>
                                    </Link>
                                }
                                <Link to={"/contact-us"} className="nav-avatar-menu-item" role="menuitem" onClick={this.closeMenu}>
                                    <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                                        <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28824 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <span>Get in touch</span>
                                </Link>
                                <div className="nav-avatar-menu-divider" />
                                <button
                                    type="button"
                                    className="nav-avatar-menu-item nav-avatar-menu-item-danger"
                                    role="menuitem"
                                    onClick={() => { this.closeMenu(); this.props.setLogOut(true); }}
                                >
                                    <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                                        <path d="M9 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M21 12H9" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <span>Sign out</span>
                                </button>
                            </div>
                        }
                    </div>
                }
                {!user.isLoggingIn && !user.isLoggedIn && !user.data
                    && !this.props?.match?.path.includes("/sign-in")
                    && !this.props?.match?.path.includes("/sign-up")
                    && !this.props?.match?.path.includes("/reset-password") &&
                    <div className="navigation-bar-right-side-items-container">
                        <Link to="/sign-in">
                            <div className="navigation-bar-sign-up-button">
                                <span className="navigation-bar-sign-up-button-text">Sign In</span>
                            </div>
                        </Link>
                    </div>
                }
            </div>
        );
        

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ setUserData, setAuth, toggleBurgerStatus, toggleBurgerMenu, setLogOut }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);